import { useContext } from "react";
import DialogComponent from "../../../common/components/functional/dialogs/DialogComponent";
import { ShiftOrderContext } from "../newOrder/short/OrderShortDataProvider";
import { OrderRow } from "../orderTypes";
import OrderFormShortAdditionalInfoContent from "./OrderFormShortAdditionalInfoContent";

type Props = {
  row: OrderRow;
  bundleRowId: string | undefined;
};

const DRAG_HANDLE_SELECTOR = "drag-handle-additionalInfo";

const OrderFormShortAdditionalInfo = ({ row, bundleRowId }: Props) => {
  const { orderAdditionalInfo, handleToggleAdditionalInfo } =
    useContext(ShiftOrderContext);
  const { show, id, rowId } = orderAdditionalInfo;

  if (row.rowId !== rowId) return null;

  const values = row.rows.find((row) => row.id === id);

  return values ? (
    <DialogComponent
      variant="card"
      DialogContentProps={{
        sx: {
          padding: "0",
          height: "85vh",
          overflowY: "auto",
        },
      }}
      open={show}
      dragHandleSelector={DRAG_HANDLE_SELECTOR}
      onClose={() => handleToggleAdditionalInfo()}
      autoWidth
    >
      <OrderFormShortAdditionalInfoContent
        row={row}
        rowId={row.rowId}
        values={values}
        bundleRowId={bundleRowId}
      />
    </DialogComponent>
  ) : null;
};

export default OrderFormShortAdditionalInfo;
